import type { Listing } from '@thevillages/schemas';

import type { CreateSavedItemListing } from '../../types/saved-items/create-listing';

export function MapListingToSavedItem(listing: Listing): CreateSavedItemListing {
  const _output: CreateSavedItemListing = {
    ...listing,
    address: { ...listing.address, uliKey: listing.uliKey },
    baths: listing.baths?.value ?? listing.baths?.full,
    communities: [{ id: 'villages', title: 'Villages' }],
    created: new Date(),
    images: listing.primaryImage,
    itemId: listing.id,
    model: listing.model?.id,
    originalPrice: listing.originalPrice ? listing.originalPrice : listing.price,
    type: 'listing',
    village: listing.village.id,
  };

  return _output;
}
